jQuery(document).ready(function ($) {
	var $menu = $(".menu-responsive-wrap-mobile");
	var $back = $(".back-menu");

	// Stack to track parent IDs
	var menuStack = [];

	// Open mobile menu
	$(".open-mobile-menu").click(function () {
		// Full reset
		$(".menu-item").removeClass("active");
		$(".sub-menu").removeClass("level-1 level-2");
		$(".menu-item-has-children").removeClass(
			"level-1-hold level-2-hold is-active",
		);
		$(".open-menu").removeClass("level-1-open level-2-open");

		menuStack = [];

		$("body").addClass("menu-is-open");
		$menu.addClass("is-active");

		$(".menu-item[data-level='1']").addClass("active");
		$back.removeClass("active");
	});

	// Close mobile menu
	$(".close-mobile-menu").click(function () {
		$("body").removeClass("menu-is-open");
		$menu.removeClass("is-active");

		// Remove active state from ALL items
		$(".menu-item").removeClass("active");

		// Remove submenu state classes
		$(".sub-menu").removeClass("level-1 level-2");
		$(".menu-item-has-children").removeClass(
			"level-1-hold level-2-hold is-active",
		);

		$(".open-menu").removeClass("level-1-open level-2-open");

		$back.removeClass("active");

		menuStack = [];
	});

	// Open submenu (Levels 2, 3, 4)
	$(".mobile-nav").on("click", ".open-menu", function (e) {
		e.preventDefault();

		var $parentItem = $(this).closest(".menu-item");
		var parentId = $parentItem.data("id");
		var level = $parentItem.data("level");

		// Push current parent ID to stack
		menuStack.push(parentId);

		// Hide all items first
		$(".menu-item").removeClass("active");

		// Show only the direct children of the clicked item
		$(".menu-item")
			.filter(function () {
				return $(this).data("parent") === parentId;
			})
			.addClass("active");

		// Show back button
		$back.addClass("active");

		// If level 2 is clicked, make sure level 3 items show up
		if (level === 2) {
			$(".menu-item[data-parent='" + parentId + "'][data-level='3']").addClass(
				"active",
			);
		}
	});

	// Back button
	$back.click(function () {
		if (menuStack.length === 0) {
			// Already at top level
			return;
		}

		// Pop last parent ID
		menuStack.pop();

		// Hide all items
		$(".menu-item").removeClass("active");

		if (menuStack.length === 0) {
			// Back to top level → show all level 1 items
			$(".menu-item[data-level='1']").addClass("active");
			$back.removeClass("active");
		} else {
			// Show children of new last parent
			var lastParentId = menuStack[menuStack.length - 1];
			$(".menu-item")
				.filter(function () {
					return $(this).data("parent") === lastParentId;
				})
				.addClass("active");
		}

		// Hide level 3 and 4 when going back
		$(".menu-item[data-level='3'], .menu-item[data-level='4']").removeClass(
			"active",
		);
	});
});
